import React from 'react';
import { Row, Col, Well, Button, Image } from 'react-bootstrap';
import { Redirect } from "react-router-dom";
import TextField from '../components/TextField';

import './Index.css';

const USER = 'admin';
const PASS = 'admin';

export default class Index extends React.Component {

    state = {
        redirectToReferrer: false,
        fieldStatus: 'success'
    };

    login = () => {
        if (this.state.user === USER && this.state.pass === PASS) {
            this.setState({ redirectToReferrer: true });
        } else {
            this.setState({ fieldStatus: 'error' });
            alert('Usuário ou senha inválidos')
        }
    };

    render() {
        const { from } = this.props.location.state || { from: { pathname: "/home" } };
        const { redirectToReferrer } = this.state;

        if (redirectToReferrer) {
            return <Redirect to={from} />;
        }

        return (
            <Row>
                <Col xs={12} sm={4} smOffset={4}>
                    <Well>
                        <Row>
                            <Col xs={12}>
                                <Image
                                    src="/img/logo.png"
                                    className="imageContainer"
                                    responsive />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <TextField
                                    id="username"
                                    type="text"
                                    placeholder="Usuário"
                                    onChange={(event) => this.setState({ user: event.target.value })}
                                    state={this.state.fieldStatus}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <TextField
                                    id="password"
                                    type="password"
                                    placeholder="Senha"
                                    onChange={(event) => this.setState({ pass: event.target.value })}
                                    state={this.state.fieldStatus}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <Button
                                    id="loginBtn"
                                    onClick={this.login}
                                    bsStyle="primary"
                                    block
                                >
                                    Entrar
                                </Button>
                            </Col>
                        </Row>
                    </Well>
                </Col>
            </Row>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/Index.jsx